import '../styles/fonts.css';
import '../styles/globals.css';
import '../styles/reset.css';

import { FloorProvider } from '@auth-v2';
import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '@queries';
import { StoreProvider } from '@store';

import { FloorScreen } from '../screens/FloorScreen';

import { ActivityGuard } from './ActivityGuard';
import { QueryLoader } from './QueryLoader';
import { UserGuard } from './UserGuard';

export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <StoreProvider>
                <FloorProvider>
                    <QueryLoader>
                        <UserGuard>
                            <ActivityGuard>
                                <FloorScreen />
                            </ActivityGuard>
                        </UserGuard>
                    </QueryLoader>
                </FloorProvider>
            </StoreProvider>
        </QueryClientProvider>
    );
}
